import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface ProductAttribute {
	readonly description: string;
	readonly value: string;
}

export interface ListAllProductAttributesResponseModel {
	readonly attributes: Record<string, ProductAttribute[]>;
}

export const useListAllProductAttributes = () => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["allProductAttributes"],
		queryFn: () => {
			return http<ListAllProductAttributesResponseModel>({
				method: "GET",
				url: "/product/attributes"
			});
		}
	});
};
